var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15181 3.68847C5.34794 3.49408 5.34935 3.1775 5.15496 2.98137C4.96058 2.78524 4.644 2.78383 4.44787 2.97822L3.4871 3.93044C3.12965 4.2847 2.83153 4.58016 2.61897 4.84484C2.39601 5.12245 2.22643 5.41422 2.18112 5.76968C2.17138 5.84615 2.1665 5.92308 2.1665 6.00001C2.1665 6.07694 2.17138 6.15387 2.18112 6.23034C2.22643 6.5858 2.39601 6.87757 2.61896 7.15518C2.83153 7.41986 3.12965 7.71532 3.4871 8.06957L4.44786 9.0218C4.644 9.21619 4.96058 9.21478 5.15496 9.01865C5.34935 8.82252 5.34794 8.50594 5.15181 8.31155L4.21156 7.37965C3.82829 6.99979 3.57139 6.7441 3.39866 6.52902C3.39074 6.51915 3.38309 6.50949 3.3757 6.50001H9.3332C10.898 6.50001 12.1665 7.76854 12.1665 9.33334C12.1665 10.8982 10.898 12.1667 9.3332 12.1667H3.99987C3.72373 12.1667 3.49987 12.3905 3.49987 12.6667C3.49987 12.9428 3.72373 13.1667 3.99987 13.1667H9.3332C11.4503 13.1667 13.1665 11.4504 13.1665 9.33334C13.1665 7.21625 11.4503 5.50001 9.3332 5.50001H3.3757C3.38308 5.49053 3.39073 5.48087 3.39866 5.471C3.57139 5.25592 3.82829 5.00023 4.21156 4.62037L5.15181 3.68847Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.34198c1076a05a8873dc74cb9a114b95.svg";
export { ForwardRef as ReactComponent };